import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import * as echarts from "echarts";

/**
 * 依次点击未展开的 Ant Design Collapse 面板头，直到全部展开（支持嵌套）。
 */
export async function expandAllAntCollapses(root) {
  if (!root || typeof root.querySelectorAll !== "function") return;
  const maxPasses = 25;
  for (let p = 0; p < maxPasses; p += 1) {
    const headers = root.querySelectorAll(
      ".ant-collapse-item:not(.ant-collapse-item-active) .ant-collapse-header",
    );
    if (!headers.length) break;
    headers.forEach((h) => h.click());
    await new Promise((r) => setTimeout(r, 380));
  }
}

function resizeEchartsIn(root) {
  if (!root) return;
  const nodes = root.querySelectorAll("div");
  nodes.forEach((el) => {
    try {
      const inst = echarts.getInstanceByDom(el);
      if (inst) inst.resize();
    } catch {
      /* ignore */
    }
  });
}

function hideExportUi(hidden) {
  document.querySelectorAll("[data-panorama-export-ui]").forEach((el) => {
    el.style.visibility = hidden ? "hidden" : "";
    el.style.pointerEvents = hidden ? "none" : "";
  });
}

/**
 * 展开折叠、触发图表重绘后，将 DOM 区域截图为多页 A4 PDF 并下载。
 * @param {HTMLElement} element
 * @param {string} filenameBase 不含扩展名
 */
export async function capturePanoramaToPdf(element, filenameBase) {
  if (!element) {
    throw new Error("截图区域不存在");
  }

  await expandAllAntCollapses(element);
  await new Promise((r) => setTimeout(r, 400));
  window.dispatchEvent(new Event("resize"));
  resizeEchartsIn(element);
  await new Promise((r) => setTimeout(r, 280));

  hideExportUi(true);
  await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

  try {
    const canvas = await html2canvas(element, {
      scale: Math.min(2, (window.devicePixelRatio || 1) * 1.5),
      useCORS: true,
      allowTaint: true,
      logging: false,
      backgroundColor: "#ffffff",
      scrollX: 0,
      scrollY: 0,
      width: element.scrollWidth,
      height: element.scrollHeight,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png", 1.0);
    const pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 8;
    const usableW = pdfWidth - 2 * margin;
    const usableH = pdfHeight - 2 * margin;
    const imgH = (canvas.height * usableW) / canvas.width;

    let heightLeft = imgH;
    let y = margin;

    pdf.addImage(imgData, "PNG", margin, y, usableW, imgH);
    heightLeft -= usableH;

    while (heightLeft > 0) {
      y = margin - (imgH - heightLeft);
      pdf.addPage();
      pdf.addImage(imgData, "PNG", margin, y, usableW, imgH);
      heightLeft -= usableH;
    }

    const name = filenameBase.endsWith(".pdf") ? filenameBase : `${filenameBase}.pdf`;
    pdf.save(name);
  } finally {
    hideExportUi(false);
  }
}
